export default ".title {\n  border-bottom: 1px solid #eeeeee;\n}"